import React, {useEffect, useState} from 'react';

// bootstrap
import ToggleButton from 'react-bootstrap/ToggleButton';
import Button from 'react-bootstrap/Button';

// styling
import { Spacing } from '_styles';

const CheckBox = (props) => {

    const [checked, setChecked] = useState(false);

    const handleClick = () => {
        setChecked(!checked);
        props.handleButtonClick(props.children)
    }

    useEffect(() => {
       // console.log('checked', props)
        if(props.checked){ 
            setChecked(props.checked)
        }
    }, [props]); 

    return (
        <div style={{ display:'flex', marginTop:2, marginLeft:2, marginRight:2, marginBottom:4 }}>
            <Button 
                style={{ height:30, width:30}}
                onClick={handleClick}
                variant={checked ? 'primary' : 'outline-primary'}
            />
            <p style={{
                marginLeft: Spacing.SCALE_4,
                opacity: checked ? 1.0 : 0.6,
                fontWeight: checked ? '600' : '400',
                fontSize:16
            }}>{props.children}</p>
        </div>
    );
};

export default CheckBox;
